import { DataSource } from '@n7-frontend/core';
import { ITableData } from '@n7-frontend/components';
import {Utils} from './utils';
export class RealEstatesDS extends DataSource {
  protected transform(data): ITableData {
    if (!data || !data.realEstate || !data.realEstate.items) {
      return;
    }

    const table = [];

    const getEstimation = function(realEstate){
      let min = Utils.bigNumberConverter(realEstate.base.estimation.average.min);
      let max = Utils.bigNumberConverter(realEstate.base.estimation.average.max);
      return  `<span>${min}-${max} €</span>`
    }

    data.realEstate.items.forEach(realEstate => {  
      const hasCategory = realEstate.base && realEstate.base.cadastralInfo && realEstate.base.cadastralInfo.category;
      const hasEstimation = realEstate.base && realEstate.base.estimation && realEstate.base.estimation.average;
      const hasAddress = realEstate.base && realEstate.base.address;
      const indirizzo =  (hasAddress && (realEstate.base.address.fullAddress || realEstate.base.address.municipality)) || '<span class="info-not-available">Dato non disponibile</span>';
      const provincia = (hasAddress && realEstate.base.address.province) || '<span class="info-not-available">Dato non disponibile</span>';
      const categoria = (hasCategory && realEstate.base.cadastralInfo.category.label) || '<span class="info-not-available">Dato non disponibile</span>';
      const percentuale = (realEstate.owner && realEstate.owner.ratio && `${realEstate.owner.ratio * 100}%`) || '<span class="info-not-available">Dato non disponibile</span>';
      const dimensioni = realEstate.size && realEstate.size.value && realEstate.size.unit ? `${realEstate.size.value} ${realEstate.size.unit}` : '<span class="info-not-available">Dato non disponibile</span>';
      const stima = hasEstimation ? getEstimation(realEstate) : '<span class="info-not-available">Dato non disponibile</span>';
      table.push({
        classes: 'BODY',
        cells: [
          {
            classes: 'CONTENT',
            content: indirizzo,
            type: 'html'
          },
          {
            classes: 'CONTENT',
            content: provincia,
            type: 'html'
          },
          {
            classes: 'CONTENT',
            content: categoria,
            type: 'html'
          },
          {
            classes: 'CONTENT',
            content: percentuale,
            type: 'html'
          },
          {
            classes: 'CONTENT',
            content: dimensioni,
            type: 'html'
          },
          {
            classes: 'CONTENT',
            content: stima,
            type: 'html'
          }
        ]
      });
    });

    const header = [
      {
        classes: 'HEADER',
        cells: [
          {
            classes: 'CONTENT',
            content: 'Indirizzo'
          },
          {
            classes: 'CONTENT',
            content: 'Provincia'
          },
          {
            classes: 'CONTENT',
            content: 'Categoria Catastale'
          },
          {
            classes: 'CONTENT',
            content: 'Percentuale posseduta'
          },
          {
            classes: 'CONTENT',
            content: 'Dimensioni'
          },
          {
            classes: 'CONTENT',
            content: 'Stima'
          }
        ]
      }
    ]

    return {
      classes: 'test-layout-table',
      head: header,
      body: table
    };
  }
}
